import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { useSelector } from 'react-redux';

const ModalModificarMenuPermission = ({ isOpen, toggle, selectedMenuPermission, onSave }) => {
    const tenantId = useSelector((state) => state.Context.tenantId);

    const [formData, setFormData] = useState({
        menu_id: '',
        role: '',
    });

    useEffect(() => {
        if (selectedMenuPermission) {
            setFormData({
                menu_id: selectedMenuPermission.menu_id || '',
                role: selectedMenuPermission.role || '',
            });
        }
    }, [selectedMenuPermission]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSave = () => {
        formData.tenantId = tenantId
        onSave(formData);
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Modificar Permiso de Menú</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="menu_id">ID de Menú</Label>
                        <Input type="text" name="menu_id" id="menu_id" value={formData.menu_id} onChange={handleChange} disabled={true} />
                    </FormGroup>
                    <FormGroup>
                        <Label for="role">Rol</Label>
                        <Input type="text" name="role" id="role" value={formData.role} onChange={handleChange} />
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleSave}>Guardar</Button>
                <Button color="secondary" onClick={toggle}>Cancelar</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalModificarMenuPermission;